import type { GetSearchUrl } from '../getSearchUrl'

/**
 * Generates an Avanquest-specific search URL with variant-specific PID
 * Used for Avanquest A/B testing of branded vs unbranded experiences
 *
 * @param searchTerm - The search term to encode
 * @param pid - The PID to use in the URL (NT260101 for branded, NT260102 for unbranded)
 * @returns GetSearchUrl object with the lusearch.com URL
 */
export function getAvanquestSearchUrl(
  searchTerm: string,
  pid: string
): GetSearchUrl {
  const encodedSearchTerm = encodeURIComponent(searchTerm)
  const url = `https://lusearch.com/?br=Chrome&searchEngine=Yahoo&pid=${pid}&bitmask=9998&q=${encodedSearchTerm}`

  return {
    url,
    isMonetized: true,
  }
}
